import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGiroCards: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="giro-cards"><path fillRule="evenodd" clipRule="evenodd" d="M2 4.75C2 4.33579 2.33579 4 2.75 4H17.25C17.6642 4 18 4.33579 18 4.75V8H21.25C21.6642 8 22 8.33579 22 8.75V19.25C22 19.6642 21.6642 20 21.25 20H6.75C6.33579 20 6 19.6642 6 19.25V16H2.75C2.33579 16 2 15.6642 2 15.25V4.75ZM7.5 16V18.5H20.5V9.5H18V15.25C18 15.6642 17.6642 16 17.25 16H7.5ZM6 8.75C6 8.33579 6.33579 8 6.75 8H8.25C8.66421 8 9 8.33579 9 8.75C9 9.16421 8.66421 9.5 8.25 9.5H6.75C6.33579 9.5 6 9.16421 6 8.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconGiroCards;
